import TabUrlParameters from '@anm/components/video-landings/TabUrlParameters';
import { callToActionFields } from '@anm/data/video-landings/form';
import { Config as FinalFormConfig } from 'final-form';
import { useCallback, FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import { TextField } from '../fields';

import { ControlGroup, FormWrapper } from './Wrapper';

type HOCs = FinalFormConfig;

type CallToActionFormProps = {
  onChange: (value: any) => void;
  isPending?: boolean;
};

const renderForm = ({ onChange: handleChange }: CallToActionFormProps) => ({
  handleSubmit,
  values
}: FormRenderProps) => {
  const handleFormBlur = useCallback(() => {
    handleChange(values);
  }, [values]);

  return (
    <FormWrapper onSubmit={handleSubmit} onBlur={handleFormBlur}>
      <ControlGroup>
        <TextField
          name="buttonText"
          label="Button text "
          placeholder="Sign up"
          inputVariant="simple-small"
          labelVariant="static-above"
        />
        <TabUrlParameters
          useForm={false}
          onFormBlur={handleChange}
          fields={callToActionFields}
          formInitialValues={values}
        >
          <TextField
            name="buttonLink"
            label="Button link"
            placeholder="Paste your link here"
            inputVariant="simple-small"
            labelVariant="static-above"
          />
        </TabUrlParameters>
      </ControlGroup>
    </FormWrapper>
  );
};

const CallToActionForm: FC<HOCs & CallToActionFormProps> = props => (
  <Form render={renderForm(props)} {...props} />
);

export default CallToActionForm;
